import { MODE } from '../../constants';
import CyberSportFavoriteEvents from './CyberSportFavoriteEvents';

export const CyberSportFavoritePreMatchEvents = (props) => (
  <CyberSportFavoriteEvents serviceId={MODE.PRE_MATCH} {...props} />
);
